import type {PricingContext} from "#pricing/pricing-context"
import type {NodeParameters} from "@cm/graph-v3"
import {GraphNode, registerGraphNodeIn} from "@cm/graph-v3"

export const registerPricingGraphNode = registerGraphNodeIn("pricing")

export abstract class PricingNode<
    Returns = unknown,
    Parameters extends NodeParameters = NodeParameters,
    ConstructorParameters extends NodeParameters = Parameters,
> extends GraphNode<Returns, PricingContext, Parameters, ConstructorParameters> {}
